import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFilter = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 13,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 14 12",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11 4.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM11 6a3 3 0 1 0-2.905-3.75H.75a.75.75 0 0 0 0 1.5h7.345A3.001 3.001 0 0 0 11 6ZM4.5 9a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm1.405.75A3.001 3.001 0 0 1 0 9a3 3 0 0 1 5.905-.75h7.345a.75.75 0 1 1 0 1.5H5.905Z",
		fill: "currentColor"
	})
});
export default SvgFilter;
